import React, { createContext, useCallback, useContext, useMemo, useState } from "react";

const ClientContext = createContext(null);
const TAB_SELECTION_STORAGE_PREFIX = "ledgerhub-tab-selection:";

function readStoredTabSelection(tabKey) {
  if (typeof window === "undefined") return "";
  return window.sessionStorage.getItem(`${TAB_SELECTION_STORAGE_PREFIX}${tabKey}`) || "";
}

function writeStoredTabSelection(tabKey, value) {
  if (typeof window === "undefined") return;
  if (value) {
    window.sessionStorage.setItem(`${TAB_SELECTION_STORAGE_PREFIX}${tabKey}`, value);
  } else {
    window.sessionStorage.removeItem(`${TAB_SELECTION_STORAGE_PREFIX}${tabKey}`);
  }
}

export function ClientProvider({ children }) {
  const [pinnedClientId, setPinnedClientId] = useState(
    () => sessionStorage.getItem("pinnedClientId") || ""
  );
  const [pinnedClientName, setPinnedClientName] = useState(
    () => sessionStorage.getItem("pinnedClientName") || ""
  );

  const pinClient = useCallback((id, name, tabKey = "default") => {
    setPinnedClientId(id);
    setPinnedClientName(name || "");
    sessionStorage.setItem("pinnedClientId", id);
    sessionStorage.setItem("pinnedClientName", name || "");
    writeStoredTabSelection(tabKey, id);
  }, []);

  const clearPin = useCallback(() => {
    setPinnedClientId("");
    setPinnedClientName("");
    sessionStorage.removeItem("pinnedClientId");
    sessionStorage.removeItem("pinnedClientName");
  }, []);

  const value = useMemo(() => ({
    pinnedClientId,
    pinnedClientName,
    pinClient,
    clearPin,
    readStoredTabSelection,
    writeStoredTabSelection,
  }), [pinnedClientId, pinnedClientName, pinClient, clearPin]);

  return (
    <ClientContext.Provider value={value}>
      {children}
    </ClientContext.Provider>
  );
}

export function useClient() {
  return useContext(ClientContext);
}

